<template>
  <v-text-field
    v-bind="$attrs"
    :label="label"
    :suffix="suffix"
    :isFloat="isFloat"
    :value="formattedValue"
    @input="handleInput"
    @keydown="handleKeyDown"
    :key="fieldKey"
  />
</template>

<script>
export default {
  name: "NumberInput",
  props: {
    value: [String, Number], // para v-model
    label: String,
    suffix: String,
    isFloat: Boolean
  },
  data: () => ({
    fieldKey: 0
  }),
  computed: {
    formattedValue() {
      if (this.value === '' || this.value === null || this.value === undefined) return '';
      const number = parseFloat(this.value);
      if (isNaN(number)) return '';
      return number.toLocaleString('pt-BR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    }
  },
  methods: {
    handleKeyDown(event) {
      // Permite: números, vírgula, backspace, delete, tab, enter, setas
      const allowedKeys = [
        'Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight',
        'ArrowUp', 'ArrowDown', 'Home', 'End'
      ];
      
      // Se for uma tecla permitida, deixa passar
      if (allowedKeys.includes(event.key)) {
        return true;
      }

      if(!this.isFloat){
        if(event.key === ','){
          event.preventDefault();
          return false;
        }
      }
      

      // Se for uma vírgula, verifica se já existe uma no valor
      if (event.key === ',') {
        const currentValue = event.target.value;
        if (currentValue.includes(',')) {
          event.preventDefault();
          return false;
        }
        return true;
      }
      
      // Se não for um número, previne a entrada
      if (!/^\d$/.test(event.key)) {
        event.preventDefault();
        return false;
      }
      
      return true;
    },
    handleInput(val) {
      // Remove todos os caracteres não numéricos exceto vírgula
      const cleanValue = val.replace(/[^\d,]/g, '');
      
      // Se o valor estiver vazio, emite vazio
      if (cleanValue === '') {
        this.$emit('input', '');
        this.$emit('change', '');
        return;
      }

      // Converte o formato brasileiro para float
      const floatValue = parseFloat(cleanValue.replace(',', '.'));
      
      if (!isNaN(floatValue)) {
        this.$emit('input', floatValue);
        this.$emit('change', floatValue);
      }
    }
  },

};
</script>